var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen",attrs:{"id":"fullscreen"}},[_c('div',{ref:"rootmap",staticClass:"map",attrs:{"id":"map"}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ol-popup",attrs:{"id":"popup"}},[_c('a',{staticClass:"ol-popup-closer",attrs:{"href":"#","id":"popup-closer"}}),_c('div',{staticStyle:{"width":"300px","height":"120px"},attrs:{"id":"popup-content"}})])
}]

export { render, staticRenderFns }